export const RESET_STATES = 'resetState'



// WEBPACK FOOTER //
// ./src/store/types.js